import moment from 'moment';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionType, AppcuesConstant, constants, LiveMeetingInt, Minutes, Tag } from '../../../../assets/constants/constants';
import { AppContext } from '../../../../context/AppProvider';
import getLocalizedContent from '../../../../lib/getLocalizedMetaData';
import { covertDateUtcToIST, defaultImage } from '../../../../lib/utils';
import PlayButton from '../../../common/PlayButton';
import CoursePlayer from '../../../common/player/CoursePlayer';
import { FullScreenPlayer } from '../../../common/player/FullScreenPlayer';
import { ExerciseContent } from '../../../common/scorm-exercise-poc/ExerciseContent';
import { appcues_event } from '../../../../assets/constants/staticContentConstants';
import { putAppCuesData } from '../../../../lib/appcues';
import { completLiveClassMeeting, getMultileExerciseStatus } from '../../../../services/user';

type CoursePlayerSectionProps = {
  programData: any;
  courseId: any;
  playCourse: any;
  courseResponse: any;
  courseRelationshipsInstancesLoResourcesId: any;
  courseList: any;
  updateCompaletedStatus: any;
  courseUpdate: any;
  setPlayCourse: any;
  currentLesson: any;
  courseModuleProgress?: any;
  setCourseModuleProgress?: any;
  liveMeetingDetail?: any;
  currentLessionDetail: any;
  exerciseModule: any;
  completedCourses: any;
};
export const CoursePlayerSection: React.FC<CoursePlayerSectionProps> = ({
  programData,
  courseId,
  playCourse,
  courseResponse,
  courseRelationshipsInstancesLoResourcesId,
  courseList,
  updateCompaletedStatus,
  courseUpdate,
  setPlayCourse,
  currentLesson,
  liveMeetingDetail,
  currentLessionDetail,
  exerciseModule,
  completedCourses
}) => {
  const { state, dispatch } = useContext(AppContext);
  const { t } = useTranslation();

  const showFluidicPlayer = async () => {
    const isExercise = courseList[currentLesson - 1]?.isExercise;
    if (isExercise) {
      const exerciseStatus: any = await getMultileExerciseStatus(currentLessionDetail.id);
      if (exerciseStatus?.data?.length === 1 && exerciseStatus?.data[0]?.isCourseCompleted) {
        updateCompaletedStatus(currentLessionDetail.id)
      }
    }
    setPlayCourse(true)
  }


  const getPlayer = () => {
    const isExercise = courseList[currentLesson - 1]?.isExercise
    const props = {
      cid: courseResponse?.id,
      mid: courseRelationshipsInstancesLoResourcesId,
      goBackUrl: location?.pathname,
      fullScreen: isExercise,
      courseUpdate: courseUpdate,
      courseList: courseList,
      playVideo: setPlayCourse,
      updateCompaletedStatus: updateCompaletedStatus,
      program_id: programData?.data?.id,
      program_name: getLocalizedContent(
        programData?.data?.attributes?.localizedMetadata, constants.dutchLocale
      )?.name.trim(),
      courseType: getCourseType()
    }

    return isExercise ? (currentLessionDetail?.tags?.filter((item: string) => item.split(':')[0] === Tag.exercise.toLocaleLowerCase())?.length > 0) ? <ExerciseContent
      currentLessionDetail={currentLessionDetail}
      programData={programData}
      programId={props?.program_id}
      programName={props?.program_name}
      courseId={props?.cid}
      userId={state?.user?.userId}
      playVideo={setPlayCourse}
      updateCompaletedStatus={updateCompaletedStatus}
      exerciseModule={exerciseModule}
      completedCourses={completedCourses}
    /> : <FullScreenPlayer {...props} />
      : <CoursePlayer {...props} />
  }

  const playBtnAction = () => {
    //check if the live lession has meeting and has no recording
    const liveClassdateStart_ = liveMeetingDetail?.attributes?.dateStart; //'2024-07-15T9:22:00.000Z';
    const completionDeadline_ = liveMeetingDetail?.attributes?.completionDeadline; //'2024-07-15T10:30:00.000Z';
    const courseType = getCourseType();
    if (courseType !== AppcuesConstant.meeting) {
      putAppCuesData({
        event_Name: appcues_event.lessonStarted,
        eventName: `${appcues_event.lessonStarted}_${currentLessionDetail?.id}_${currentLessionDetail.name}`,
        userId: state.user?.email || "",
        program_id: programData?.data?.id,
        lesson_id: currentLessionDetail?.id,
        lesson_name: currentLessionDetail?.name,
        lesson_type: courseType !== null ? courseType : AppcuesConstant.otherContent
      });
      if(courseType!==AppcuesConstant.Exercise){
        putAppCuesData({
          event_Name: appcues_event.lessonCompleted,
          eventName: `${appcues_event.lessonCompleted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
          userId: state.user?.email || "",
          program_id: programData?.data.id,
          lesson_id: currentLessionDetail?.id,
          lesson_name: currentLessionDetail?.name,
          lesson_type: courseType !== null ? courseType : AppcuesConstant.otherContent,
        });
      }
    }
    
    const startTime = covertDateUtcToIST(liveClassdateStart_, state?.user?.timeZoneCode);
    const endTime = covertDateUtcToIST(completionDeadline_, state?.user?.timeZoneCode);
    const startBeforeFifteenMint = moment(startTime).subtract(LiveMeetingInt, Minutes);
    const isLiveclass = courseList[currentLesson - 1].liveclass;

    const datetimeNow = moment();
    const formattedDateTime = datetimeNow.toISOString();
    const datetimeZone = covertDateUtcToIST(formattedDateTime, state?.user?.timeZoneCode);
    //check if live lession has started and not completed yet. 
    if (isLiveclass && !courseRelationshipsInstancesLoResourcesId) {
      if (moment(datetimeZone.format(moment.HTML5_FMT.DATETIME_LOCAL)).isBetween(
        startBeforeFifteenMint?.format(moment.HTML5_FMT.DATETIME_LOCAL),
        endTime?.format(moment.HTML5_FMT.DATETIME_LOCAL))) {
        putAppCuesData({
          event_Name: appcues_event.lessonStarted,
          eventName: `${appcues_event.lessonStarted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
          userId: state.user?.email,
          program_id: programData.data.id,
          lesson_id: currentLessionDetail?.id,
          lesson_name: currentLessionDetail?.name,
          lesson_type: courseType !== null ? courseType : AppcuesConstant.otherContent,
        })
        putAppCuesData({
          event_Name: appcues_event.lessonCompleted,
          eventName: `${appcues_event.lessonCompleted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
          userId: state.user?.email || "",
          program_id: programData?.data.id,
          lesson_id: currentLessionDetail?.id,
          lesson_name: currentLessionDetail?.name,
          lesson_type: courseType !== null ? courseType : AppcuesConstant.otherContent,
        });
        //open meeting link in new tab if the meeting has started and not completed yet.
        if (currentLessionDetail?.state !== constants.COMPLETED) {
          completLiveClassMeeting(courseResponse?.id)
        }
        //open meeting link in new tab if the meeting has
        window.open(liveMeetingDetail?.attributes?.location)
      }
      else if (moment(moment().format(moment.HTML5_FMT.DATETIME_LOCAL)).isAfter(endTime)) {
        dispatch({
          type: ActionType.ALERT_BOX, payload: {
            visible: true,
            message: t('Program.noWatchRecording')
          }
        })
      }
      else {
        dispatch({
          type: ActionType.ALERT_BOX, payload: {
            visible: true,
            message: t('Common.meetingNotStarted')
          }
        })
      }
    } else if (isLiveclass && courseRelationshipsInstancesLoResourcesId) {
      putAppCuesData({
        event_Name: appcues_event.lessonStarted,
        eventName: `${appcues_event.lessonStarted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
        userId: state.user?.email || "",
        program_id: programData?.data.id,
        lesson_id: currentLessionDetail?.id,
        lesson_name: currentLessionDetail?.name,
        lesson_type: courseType !== null ? courseType : AppcuesConstant.otherContent,
      });
      putAppCuesData({
        event_Name: appcues_event.lessonCompleted,
        eventName: `${appcues_event.lessonCompleted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
        userId: state.user?.email || "",
        program_id: programData?.data.id,
        lesson_id: currentLessionDetail?.id,
        lesson_name: currentLessionDetail?.name,
        lesson_type: courseType !== null ? courseType : AppcuesConstant.otherContent,
      });
      //completed lesstion when meting over and recording added.
      if (currentLessionDetail?.state !== constants.COMPLETED) {
        completLiveClassMeeting(courseResponse?.id)
      }
      showFluidicPlayer()
    } else {
      showFluidicPlayer()
    }
  }
  //Get button text for course type
  const getCourseType = () => {
    const isLiveclass = courseList[currentLesson - 1]?.liveclass
    const isExercise = courseList[currentLesson - 1]?.isExercise;
    const isDocument = courseList[currentLesson - 1]?.isDocument;
    const isVideo = courseList[currentLesson - 1]?.tags && courseList[currentLesson - 1]?.tags?.includes(Tag.videos);

    const completionDeadline_ = liveMeetingDetail?.attributes?.completionDeadline; //'2024-07-15T10:30:00.000Z';
    const endTime = covertDateUtcToIST(completionDeadline_, state?.user?.timeZoneCode);

    if (isExercise)
      return constants.EXERCISE
    else if (isLiveclass) {
      if (courseRelationshipsInstancesLoResourcesId)
        return constants.recording;
      else if (moment(moment().format(moment.HTML5_FMT.DATETIME_LOCAL)).isAfter(endTime))
        return constants.meetingAlreadyCompleted;
      else
        return constants.MEETING;
    }
    else if (isDocument) {
      return constants.DOCUMENT;
    }
    else if (isVideo) {
      return constants.VIDEOS;
    }
    return null
  }
  return (
    <div className="mb-6 max-h-[568px] aspect-[6/3] md:aspect-[6/3] xl:aspect-[6/3] 2xl:aspect-[6/3] relative">
      {programData && courseId && playCourse && (
        getPlayer()
      )}

      {!playCourse && courseList && courseId && currentLesson && (
        <div className={`mb-6 max-h-[568px] aspect-[6/3] md:aspect-[6/3] xl:aspect-[6/3] 2xl:aspect-[6/3] relative `}>
          {<img
            src={courseList[currentLesson - 1]?.bannerUrl
              ? courseList[currentLesson - 1]?.bannerUrl
              : defaultImage()}
            alt=""
            className="object-cover w-full max-h-[568px] rounded-2xl"
          />}
          <div className=" w-full h-full flex justify-center align-center align-middle absolute top-0">
            <div className="flex items-center justify-betweenspace-x-5 w-max h-full">
              <div>
                {
                  courseList?.length && currentLesson && <PlayButton courseType={getCourseType()} handleVideo={playBtnAction} />}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
